<template>
  <div class="d-flex align-items-center">
    <b-nav-item-dropdown
      right
      data-toggle="dropdown"
      toggle-class="d-flex align-items-center dropdown-user-link dropdown-user"
      class="dropdown-user shadow-sm"
      :disabled="userLoading"
    >
      <template #button-content>
        <b-avatar
          v-if="!userLoading"
          size="28"
          :src="picture"
          variant="light-primary"
          badge
          class="badge-minimal"
          badge-variant="success"
        >
          <GjIcon
            v-if="picture == ''"
            name="Avatar"
            size="22"
          />
        </b-avatar>
        <b-skeleton
          v-if="userLoading"
          type="avatar"
        ></b-skeleton>
        <GjIcon
          name="ChevronDown"
          size="8"
          class="ml-50 text-white"
        />
      </template>

      <b-dropdown-item
        link-class="d-flex align-items-center"
      >
        <div>
          <b-avatar
            v-if="!userLoading"
            size="40"
            :src="picture"
            variant="light-primary"
            badge
            class="badge-minimal"
            badge-variant="success"
          >
            <GjIcon
              v-if="picture == ''"
              name="Avatar"
              size="22"
            />
          </b-avatar>
          <b-skeleton
            v-if="userLoading"
            type="avatar"
          ></b-skeleton>
        </div>
        <div>
          <p class="px-50 text-sm text-main m-0 text-thick">
            {{ name }}
          </p>
          <p class="px-50 text-sm text-main m-0">
            {{ roleName }}
          </p>

        </div>
      </b-dropdown-item>

      <b-dropdown-item
        link-class="d-flex align-items-center text-main text-medium"
        :to="{ name: 'profile' }"
      >
        <GjIcon
          name="Avatar"
          class="mr-50"
        />
        <p class="px-50 text-sm text-main m-0">
          Profile
        </p>
      </b-dropdown-item>

      <b-dropdown-item
        v-show="activeOrganizationId && this.$route.name !== 'projects-select'"
        :to="activeProjectId ? { name: 'project', params: { projectId: activeProjectId } } : { name: 'projects-select' }"
        link-class="d-flex align-items-center text-main text-medium"
      >
        <GjIcon
          v-show="!activeProjectId"
          size="20"
          name="Gesture"
          class="mr-50"
        />
        <GjIcon
          v-show="activeProjectId"
          size="50"
          name="SettingsRectangle"
          class="mr-50"
        />
        <p class="px-50 text-sm text-main m-0">
          {{ activeProjectId ? 'Project Settings' : 'Select Project' }}
        </p>
      </b-dropdown-item>

      <b-dropdown-divider
        v-show="this.$route.name !== 'organization-select'"
      />

      <b-dropdown-item
        v-show="$can('read', 'organization') && activeOrganizationId && this.$route.name !== 'organization-select' && this.$route.name !== 'organization'"
        :to="{ name: 'organization', params: {organizationId: activeOrganizationId } }"
        link-class="d-flex align-items-center text-main text-medium"
      >
        <GjIcon
          size="50"
          name="SettingsRectangle"
          class="mr-50"
        />
        <p class="px-50 text-sm text-main m-0">
          Organization Settings
        </p>
      </b-dropdown-item>

      <b-dropdown-item
        v-show="this.$route.name !== 'organization-select' && organizationSwitch"
        :to="{ name: 'organization-select' }"
        link-class="d-flex align-items-center text-main text-medium"
      >
        <GjIcon
          v-show="activeOrganizationId"
          size="20"
          :name="'RepeatingCircle'"
          class="mr-50"
        />
        <GjIcon
          v-show="!activeOrganizationId"
          size="20"
          :name="'Gesture'"
          class="mr-50"
        />
        <p class="px-50 text-sm text-main m-0">
          {{ activeOrganizationId ? 'Switch Organization' : 'Select Organization' }}
        </p>
      </b-dropdown-item>

      <b-dropdown-divider v-if="organizationButtons" />
      <b-dropdown-item
        link-class="d-flex align-items-center text-main text-medium"
        @click="logout"
      >
        <GjIcon
          name="Signout"
          size="16"
          class="mr-50"
        />
        <p class="px-50 text-sm text-main m-0">
          Logout
        </p>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
import { avatarText } from '@core/utils/filter'
import { logoutUser } from '@/auth'

export default {
  data() {
    return {
      avatarText,
    }
  },
  computed: {
    activeOrganizationId() {
      const activeOrganization = this.$store.getters['organizationModule/getActiveOrganizationId']
      return activeOrganization || null
    },
    activeProjectId() {
      return this.$store.state.projectModule.activeProjectId || null
    },
    userData() {
      const userData = this.$store.getters['userModule/getUserData']
      return userData || {}
    },
    userLoading() {
      return this.$store.state.userModule.isLoading
    },
    name() {
      return this.userData?.firstname && this.userData?.lastname ? `${this.userData.firstname} ${this.userData.lastname}` : this.userData.email
    },
    roleName() {
      return this.userData?.role?.name
    },
    picture() {
      return this.userData?.picture || ''
    },
    organizationSwitch() {
      return this.$store.getters['appConfig/organizationSwitch']
    },
    organizationButtons() {
      return ((this.$can('read', 'organization') && this.activeOrganizationId && this.$route.name !== 'organization-select' && this.$route.name !== 'organization') || (this.$route.name !== 'organization-select' && this.organizationSwitch))
    },
  },
  methods: {
    logout() {
      logoutUser('auth-login')
    },
    redirect() {
      window.open(process.env.VUE_APP_PROFILE_URL, '_blank').focus()
    },
  },
}
</script>

<style lang="scss">
.dropdown-user {
  ul.dropdown-menu {
    width: 16rem !important;
  }
}
</style>
